import { BaseViewStore} from 'core/stores';
import { action } from "mobx";

class PatientNewFlowInsuranceEditConfirmModalStore extends BaseViewStore {

    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.isInactive = componentProps.modalParams.data.isInactive;
    }

    @action.bound
    async onConfirm() {
        try {
            await this.modalParams.data.editInsurance();
            this.modalParams.close();
        }
        catch (err) {
            return this.onUpdateError(err);
        }
    }
}

export default PatientNewFlowInsuranceEditConfirmModalStore;
